query Budgets( $first: Int
  $after: Cursor
  $filter: BudgetFilter) {
  budgets(
    first: $first
    after: $after
    filter: $filter
    orderBy: DESCRIPTION_ASC) {
       pageInfo {
      hasNextPage
      hasPreviousPage
      endCursor
    }
    nodes {
      id
      name
      _rowTimestamp
      startingBudgetDate
      endingBudgetDate
      isPrimary
      _isUpdatable
      _isDeletable
     
    }
  }
}